import { render, staticRenderFns } from "./FoodSecurity.vue?vue&type=template&id=e5877e4a&scoped=true&lang=html&"
import script from "./FoodSecurity.vue?vue&type=script&lang=js&"
export * from "./FoodSecurity.vue?vue&type=script&lang=js&"
import style0 from "./FoodSecurity.vue?vue&type=style&index=0&id=e5877e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5877e4a",
  null
  
)

component.options.__file = "FoodSecurity.vue"
export default component.exports